var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("description: "+_vm._s(_vm.entraidmapper.description)+" ")]),_c('div',[_vm._v("role: "+_vm._s(_vm.getBroleString)+" ")]),_c('div',[_vm._v("mapping name: "+_vm._s(_vm.entraidmapper.mapping_name)+" ")]),_c('div',[_vm._v("Created: "+_vm._s(_vm.entraidmapper.created))]),_c('div',[_vm._v("Edited: "+_vm._s(_vm.entraidmapper.updated))]),_c('div',{staticClass:"company-mail-endings-details-buttons mt-2"},[_c('v-btn',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.deleteshurefalse),expression:"deleteshurefalse"}],attrs:{"color":"red","disabled":_vm.is_edit},on:{"click":function($event){_vm.delete_shure?
      _vm.deleteUObject({
          url: [
            {businesses: _vm.business.id},
            {entraidmappers: _vm.entraidmapper.id}
          ],
          url_prefix: ``
      }).then(() => {
        _vm.delete_shure = false;
        _vm.$router.push({name: 'CompanyEntraIdMappers'});
      })
      :
      _vm.delete_shure = true;}}},[_vm._v(" "+_vm._s(_vm.delete_shure?'shure?':'delete')+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }